import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { generateUrl } from "../helper";
import Cookies from "js-cookie";

const candidate: AxiosInstance = axios.create({
  baseURL: generateUrl("candidate_backend"),
});

candidate.interceptors.request.use(
  function (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    const token = localStorage.getItem("token");
    if (token && token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const tenantId = "";
    // const tenantId = Cookies.get('tenantId');
    if (tenantId) {
      config.headers["x-tenant-id"] = tenantId;
    } else {
      delete config.headers["x-tenant-id"]; // ensure it’s not passed at all
    }
    return config;
  },
  function (error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error);
  }
);

candidate.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => {
    return response;
  },
  function (error: AxiosError): Promise<AxiosError> {
    return Promise.reject(error);
  }
);

export default candidate;
